import ReactDOM from 'react-dom'
import App from './App/App'

ReactDOM.render(
  <App />,
  document.getElementById('root')
)
